import { HttpContextToken } from '@angular/common/http';
import { II18nConfig } from '@app/shared/types';

export const REQUEST_CALLER_IDENTIFY = new HttpContextToken<string>(() => null);

export const REQUEST_SPECIFIC_I18N_CONFIG = new HttpContextToken<II18nConfig>(
  () => null,
);
